export const paths = {
  index: "/",
  checkout: "/checkout",
  workshops: "/workshops",
  privacyPolicy: "/privacy-policy",
  cookiePolicy: "/cookie-policy",
  pricing: "/pricing",
  nightscout: "/nightscout",
  newsletter: "/newsletter",
  medicalCoaching: "/medical-coaching",
  diabetesCoachingNl: "/nl/diabetes-coaching",
  lyumjev: "/lyumjev",
  blog: {
    index: "/blog",
    postDetails: "/blog/details",
    postCreate: "/blog/create",
  },
  diabetesmanagementapps: "/diabetesmanagementapps",
  aboutus: "/aboutus",
  dataprivacy: "/dataprivacy",
  donate: "/donate",
  zorgdomeinreferral: "/verwijzen",
  introductionsession: "/introductie",
  workmethod: "/workmethod",
  whatIsopensourcelooping: "/what-is-open-source-looping",
  fullPackages: "/full-packages",
  nightscoutTransfer: "/nightscout-transfer",
  publications: "/publications",
  communityResearch: "/community-research",
  loopDecisionGuide: "/resources/loop-decision-guide",
  contributions: "/contributions",
  openHumans: "https://www.openhumans.org/activity/open/",
  basalTestingCalculator: "/basal-testing-calculator",
  auth: {
    auth0: {
      callback: "/auth/auth0/callback",
      login: "/auth/auth0/login",
    },
    jwt: {
      login: "/auth/jwt/login",
      register: "/auth/jwt/register",
    },
    firebase: {
      login: "/auth/firebase/login",
      register: "/auth/firebase/register",
      forgotPassword: "/auth/firebase/forgot-password",
    },
    amplify: {
      confirmRegister: "/auth/amplify/confirm-register",
      forgotPassword: "/auth/amplify/forgot-password",
      login: "/auth/amplify/login",
      register: "/auth/amplify/register",
      resetPassword: "/auth/amplify/reset-password",
    },
    github: {
      login: "/auth/github/login",
    },
    microsoft: {
      login: "/auth/microsoft/login",
    },
  },
  authDemo: {
    forgotPassword: {
      classic: "/auth-demo/forgot-password/classic",
      modern: "/auth-demo/forgot-password/modern",
    },
    login: {
      classic: "/auth-demo/login/classic",
      modern: "/auth-demo/login/modern",
    },
    register: {
      classic: "/auth-demo/register/classic",
      modern: "/auth-demo/register/modern",
    },
    resetPassword: {
      classic: "/auth-demo/reset-password/classic",
      modern: "/auth-demo/reset-password/modern",
    },
    verifyCode: {
      classic: "/auth-demo/verify-code/classic",
      modern: "/auth-demo/verify-code/modern",
    },
  },
  dashboard: {
    index: "/dashboard",
    apkbuild: "/dashboard/apkbuild",
    apkbuildTrio: "/dashboard/apkbuild/trio",
    apkbuildILoop: "/dashboard/apkbuild/iloop",
    apkbuildFiles: "/dashboard/apkbuild/files",
    finance: "/dashboard/finance",
    cloudServices: {
      libreLink: "/dashboard/cloud-services/libre-link",
      mcpNightscout: "/dashboard/cloud-services/mcp-nightscout",
    },
    academy: {
      index: "/dashboard/academy",
      courseDetails: "/dashboard/academy/courses/:courseId",
    },
    profiles: "/dashboard/profiles",
    optimization: {
      index: "/dashboard/optimization",
      courseDetails1: "/dashboard/optimization/autotune",
      courseDetails2: "/dashboard/optimization/chatGPT",
      courseDetails3: "/dashboard/optimization/machinelearning",
    },
    account: "/dashboard/account",
    settings: "/dashboard/settings",
    messaging: "/dashboard/messaging",
    analytics: "/dashboard/analytics",
    blank: "/dashboard/blank",
    blog: {
      index: "/dashboard/blog",
      postDetails: "/dashboard/blog/:postId",
      postCreate: "/dashboard/blog/create",
    },
    reminders: {
      index: "/dashboard/reminders",
      basals: "/dashboard/reminders/basals",
      cr: "/dashboard/reminders/cr",
      isf: "/dashboard/reminders/isf",
    },
    aiassistant: "/dashboard/aiassistant",
    // calendar: "/dashboard/calendar",
    chat: "/dashboard/chat",
    crypto: "/dashboard/crypto",
    customers: {
      index: "/dashboard/users",
      details: "/dashboard/users/:userId",
      edit: "/dashboard/users/:userId/edit",
    },
    // monitoring: "/dashboard/monitoring",
    columnchart: "/dashboard/columnchart",
    heatmapchart: "/dashboard/heatmapchart",
    piechart: "/dashboard/piechart",
    timeseries: "/dashboard/timeseries",
    percentilechart: "/dashboard/percentilechart",
    glucosemovingaverage: "/dashboard/glucosemovingaverage",
    fileManager: "/dashboard/file-manager",
    invoices: {
      index: "/dashboard/invoices",
      details: "/dashboard/invoices/:orderId",
    },
    jobs: {
      index: "/dashboard/jobs",
      create: "/dashboard/jobs/create",
      companies: {
        details: "/dashboard/jobs/companies/:companyId",
      },
    },
    kanban: "/dashboard/kanban",
    logistics: {
      index: "/dashboard/logistics",
      fleet: "/dashboard/logistics/fleet",
    },
    mail: "/dashboard/mail",
    orders: {
      index: "/dashboard/orders",
      details: "/dashboard/orders/:orderId",
    },
    software: {
      index: "/dashboard/software",
      create: "/dashboard/software/create",
    },
    social: {
      index: "/dashboard/social",
      profile: "/dashboard/social/profile",
      feed: "/dashboard/social/feed",
    },
    basalTestingCalculator: "/dashboard/basal-testing-calculator",
    publications: "/dashboard/publications",
    wait: "/dashboard/wait",
    nightscoutTransfer: "/dashboard/nightscout-transfer",
    deleteNightscoutData: "/dashboard/delete-nightscout-data",
    paymentSuccessful: "/payment-successful",
    paymentFailed: "/payment-failed",
    workmethod: "/workmethod",
  },
  legalnotice: "/legalnotice",
  components: {
    index: "/components",
    dataDisplay: {
      detailLists: "/components/data-display/detail-lists",
      tables: "/components/data-display/tables",
      quickStats: "/components/data-display/quick-stats",
    },
    lists: {
      groupedLists: "/components/lists/grouped-lists",
      gridLists: "/components/lists/grid-lists",
    },
    forms: "/components/forms",
    modals: "/components/modals",
    charts: "/components/charts",
    buttons: "/components/buttons",
    typography: "/components/typography",
    colors: "/components/colors",
    inputs: "/components/inputs",
  },
  docs: "https://material-kit-pro-react-docs.devias.io",
  notAuthorized: "/401",
  notFound: "/404",
  serverError: "/500",
  paymentSuccessful: "/payment-successful",
  paymentFailed: "/payment-failed",
  wait: "/wait",
};
